<template lang="pug">
.cp-audio-progress
  .icon-audio
    i
    i
    i
    i
    i
  .half-wrap.right-wrap
    .half-circle.right-circle(ref="right-circle")
  .half-wrap.left-wrap
    .half-circle.left-circle(ref="left-circle")
</template>
<script>
export default {
  components: {},
  props: {
    totalTime: {
      type: Number,
      require: true
    }
  },
  data () {
    return {
      // totalTime: 30000, // ms
      timer: null,
      currentCount: 0,
      isRotate: false
    }
  },
  computed: {},
  methods: {
    rotate (percent) {
      const rightCircle = this.$refs['right-circle']
      const leftCircle = this.$refs['left-circle']
      // if (!rightCircle || !leftCircle) return

      if (percent <= 0.5) {
        rightCircle.style.transform = `rotate(${-135 + 360 * percent}deg)`
        leftCircle.style.transform = 'rotate(45deg)'
      }
      if (percent >= 0.5) {
        leftCircle.style.transform = `rotate(${45 + 360 * (percent - 0.5)}deg)`
      }
    },
    start (totalTime) {
      this.end()
      if (!this.isRotate) {
        this.isRotate = true
        this.timer = setInterval(() => {
          const totalCount = totalTime / 20
          this.currentCount += 1
          this.currentCount %= totalCount
          this.currentPercent = this.currentCount / totalCount
          this.rotate(this.currentPercent)
        }, 20)
      }
    },
    pause () {
      clearInterval(this.timer)
      this.isRotate = false
    },
    end () {
      clearInterval(this.timer)
      this.rotate(0)
      this.currentCount = 0
      this.currentPercent = 0
      this.isRotate = false
    }
  },
  created () {
    // this.startRotate()
  }
}
</script>
<style lang="stylus">
.cp-audio-progress
  width 34px
  height 34px
  position relative
  border 2px solid #46A6D9
  border-radius 50%
  .icon-audio
    width 17px
    height 17px
    position absolute
    top 6px
    left 4px
    i
      animation stretch .6s infinite ease
      background #01030d
      border-radius 5px
      bottom 0
      position absolute
      width 2px
      background #1FF7F5
      &:nth-child(2)
        left 5px
        animation-delay .1s
      &:nth-child(3)
        left 10px
        animation-delay .2s
      &:nth-child(4)
        left 15px
        animation-delay .3s
      &:nth-child(5)
        left 20px
        animation-delay .4s
  .wrap
    margin-left 100px
  .half-wrap
    top -2px
    width 17px
    height 34px
    overflow hidden
  .half-circle
    width 34px
    height 34px
    border 2px solid #0DFFE9
    border-radius 50%
    border-left 2px solid transparent
    border-bottom 2px solid transparent
    position absolute
    top 0
  .right-wrap
    position absolute
    left 15px
    .right-circle
      right 0
      transform rotate(-135deg)
  .left-wrap
    position absolute
    left -2px
  .left-circle
    transform rotate(45deg)
@keyframes rotate-left {
  0%, 50%{
    transform rotate(45deg)
  }
  100%{
    transform rotate(225deg)
  }
}
@keyframes rotate-right {
  0%{
    transform rotate(-135deg)
  }
  50%, 100%{
    transform rotate(45deg)
  }
}
@keyframes stretch {
  0% {
    height 20%
  }
  25% {
    height 60%
  }
  50% {
    height 100%
  }
  75% {
    height 60%
  }
  100% {
    height 20%
  }
}
</style>
